<template>
  <div id="centreRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <!-- <i class="iconfont iconhengxiangzhuzhuangtu"></i> -->
          <i class="iconfont iconpaihang"></i>
        </span>
        <span class="fs-xl text mx-2">总营收Top5</span>
        <dv-decoration-1
          style="
            width: 1.25rem;
            height: 0.25rem;
            position: relative;
            top: -0.0375rem;
          "
        />
      </div>
      <div class="d-flex jc-center body-box">
        <Echart
          :options="options"
          id="centreLeft1Chart"
          height="2.8rem"
          width="100%"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
      cityList: [],
      fourInterval: "",
    };
  },
  components: {
    Echart,
  },
  mounted() {
    this.submitGetMessageList();
  },
  methods: {
    newEcharts() {
      var color = [
        "rgba(248,195,248",
        "rgba(100,255,249",
        "rgba(135,183,255",
        "rgba(248,195,248",
        "rgba(100,255,249",
      ];
      let lineY = [];
      let money = [];
      var list = this.cityList;
      for (var i = 0; i < list.length; i++) {
        money.push(list[i].amount);
        var x = i;
        if (x > color.length - 1) {
          x = color.length - 1;
        }
        var data = {
          name: list[i].parkName,
          color: color[x] + ")",
          value: list[i].amount,
          itemStyle: {
            normal: {
              show: true,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: color[x] + ", 0.3)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: color[x] + ", 1)", // 100% 处的颜色
                  },
                ],
              },
              barBorderRadius: 10,
            },
            emphasis: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.1)",
            },
          },
        };
        lineY.push(data);
      }
      this.options = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
        },
        grid: {
          borderWidth: 0,
          top: "10%",
          left: "5%",
          right: "15%",
          bottom: "3%",
        },
        color: color,
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              inside: false,
            },
          },
          {
            type: "category",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              inverse: true,
              inside: false,
              textStyle: {
                color: "#b3ccf8",
                fontSize: "12",
                fontFamily: "PingFangSC-Regular",
              },
              formatter: function (val) {
                return `${val}元`;
              },
            },
            splitArea: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            data: money.reverse(), // 实现数组倒叙
          },
        ],
        xAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            zlevel: 2,
            barWidth: "10px",
            data: lineY,
            animationDuration: 1500,
            label: {
              normal: {
                color: "#b3ccf8",
                show: true,
                position: [0, "-16px"],
                textStyle: {
                  fontSize: 12,
                },
                formatter: function (a) {
                  return a.name;
                },
              },
            },
          },
        ],
      };
    },
    submitGetMessageList() {
      const that = this;
      that.$store.dispatch("getMessageList", 4);
      that.fourInterval = setInterval(() => {
        that.$store.dispatch("getMessageList", 4);
      }, 30000); //$dispatch在vue2中已废除，此处用的是elementUI中的方法，触发actions
    },
  },
  beforeDestroy() {
    clearInterval(this.fourInterval);
    this.fourInterval = null;
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    // 监听vuex中amountList的变化
    "$store.state.amountList"(val) {
      // 变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      this.cityList = val;
      this.newEcharts();
    },
  },
};
</script>

<style lang="scss">
#centreRight1 {
  // padding: 0.1rem;
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 4.8125rem;
    border-radius: 0.125rem;
    overflow: hidden;
    .body-box {
      margin-top: 0 !important;
    }
    .iconpaihang {
      color: #f4ea2a;
      font-size: 0.25rem;
    }
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
  .row-item {
    height: 0.5rem;
    line-height: 0.5rem;
  }
}
</style>